var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Input, Typography, Tooltip, withStyles } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import useStyles from "../hooks/useStyles";
var HtmlTooltip = withStyles(function (theme) {
  return {
    tooltip: {
      backgroundColor: "#D3D3D3",
      color: "black",
      minWidth: 400,
      maxWidth: 600,
      fontSize: theme.typography.pxToRem(12)
    },
    arrow: {
      color: "#D3D3D3"
    }
  };
})(Tooltip);
var StyledInput = styled(function (props) {
  return React.createElement(Input, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 1rem;\n  width: 60%;\n"], ["\n  margin: 1rem;\n  width: 60%;\n"])));
var Help = function Help(_a) {
  var getPasteUrl = _a.getPasteUrl,
    pasteDisabled = _a.pasteDisabled;
  var _b = useState(false),
    copySuccess = _b[0],
    setCopySuccess = _b[1];
  var _c = useState(false),
    rePasteDisabled = _c[0],
    setRePasteDisabled = _c[1];
  var _d = useState(),
    pasteUrl = _d[0],
    setPasteUrl = _d[1];
  var _e = useState(false),
    tooltipOpen = _e[0],
    setTooltipOpen = _e[1];
  var _f = useState(false),
    showHelp = _f[0],
    setShowHelp = _f[1];
  var t = useTranslation()[0];
  var classes = useStyles();
  var handleOpenTooltip = function handleOpenTooltip() {
    setTooltipOpen(true);
    setShowHelp(true);
  };
  var handleCloseTooltip = function handleCloseTooltip() {
    setTooltipOpen(false);
    setShowHelp(false);
    setRePasteDisabled(false);
    setPasteUrl(undefined);
    setCopySuccess(false);
  };
  var pasteHandler = function pasteHandler() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        getPasteUrl().then(function (url) {
          setPasteUrl(url);
          setRePasteDisabled(true);
        }).catch(function (error) {
          setPasteUrl(error);
        });
        return [2];
      });
    });
  };
  var copyToClipboard = function copyToClipboard() {
    var element = document.getElementById("textField");
    if (element instanceof HTMLInputElement) {
      element.select();
      document.execCommand("copy");
      setCopySuccess(true);
    }
  };
  var showHelpTooltip = function showHelpTooltip() {
    return React.createElement("div", {
      style: {
        margin: "10px"
      }
    }, React.createElement(Typography, null, t("tmcPasteDescription")), pasteUrl && React.createElement("div", null, React.createElement(StyledInput, {
      id: "textField",
      value: pasteUrl,
      "data-cy": "paste-input",
      readOnly: true
    }), document.queryCommandSupported("copy") && React.createElement(Button, {
      className: classes.blueButton,
      "data-cy": "copy-text-btn",
      onClick: copyToClipboard
    }, t("button.copy")), copySuccess && React.createElement("span", {
      style: {
        paddingLeft: "3px"
      }
    }, t("copiedConfirmation"))), React.createElement(Button, {
      className: classes.darkButton,
      onClick: pasteHandler,
      disabled: rePasteDisabled,
      "data-cy": "send-to-paste-btn"
    }, t("sendToTmcPaste")));
  };
  return React.createElement(ClickAwayListener, {
    onClickAway: handleCloseTooltip
  }, React.createElement("div", null, React.createElement(HtmlTooltip, {
    PopperProps: {
      disablePortal: false
    },
    onClose: handleCloseTooltip,
    open: tooltipOpen,
    interactive: true,
    disableFocusListener: true,
    disableHoverListener: true,
    disableTouchListener: true,
    placement: "bottom-end",
    title: showHelpTooltip(),
    arrow: true
  }, React.createElement(Button, {
    variant: "contained",
    disabled: pasteDisabled,
    onClick: showHelp ? handleCloseTooltip : handleOpenTooltip,
    "data-cy": "need-help-btn",
    className: classes.blueButton
  }, t("needHelp")))));
};
export default Help;
var templateObject_1;